import { HighlightBadge } from "@components/common/HighlightBadge";
import PremiumFeatureGate from "@components/common/premium/PremiumFeatureGate";
import { DashboardRecorder } from "@components/dashboard/DashboardRecorder";
import { useState } from "react";

export function PimsPalRecord() {
  const [isRecording, setIsRecording] = useState(false);

  return (
    <div className="flex flex-col h-full">
      <div className={isRecording ? "" : "invisible"}>
        <WarningBanner />
      </div>
      <div className="flex-1 flex flex-col align-center justify-center">
        <div>
          <PremiumFeatureGate
            featureName="Recording from PIMSPal"
            requiredPermission="scribenote:pimspal_extension"
            className="w-full"
          >
            <DashboardRecorder
              onIsRecordingChanged={setIsRecording}
            />
          </PremiumFeatureGate>
        </div>
      </div>
    </div>
  );
}

function WarningBanner() {
  return (
    <div>
      <div className="flex flex-row items-center justify-center gap-4 p-4">
        <div>
          <HighlightBadge />
        </div>
        <div className="text-center text-2xl font-bold uppercase">
          Recording in progress...
          <br />
          Do not close this panel
        </div>
        <div>
          <HighlightBadge />
        </div>
      </div>
    </div>
  );
}
